import React, { Fragment } from "react";
import PropTypes from "prop-types";
import "./Button.css";
import LoaderComponent from "../loader/Loader.jsx";
import { useNavigate } from "react-router-dom";

// Icons
import { HiArrowLeft, HiArrowRight } from "react-icons/hi";
import { TbSend } from "react-icons/tb";

function ButtonAnimated({
  text,
  onClick,
  loading = false,
  colorLoading = "white",
  to,
  style = {},
  iconRight = false,
  iconLeft = false,
  skin = "default",
  success = false,
  children,
  className = "",
  animated = false,
  ...props
}) {
  const navigate = useNavigate();
  const navigation = (to) => {
    navigate(to);
  };

  const buttonContent = (
    <>
      {iconLeft === true ? (
        <HiArrowRight className="icon left" />
      ) : (
        iconLeft && <span className="icon-left">{iconLeft}</span>
      )}
      <span className="button-text">{text || children}</span>
      {iconRight === true ? (
        <HiArrowLeft className="icon right" />
      ) : (
        iconRight && <span className="icon-right">{iconRight}</span>
      )}
    </>
  );

  if (loading) {
    return (
      <button
        className={`Button ${skin} loading ${className}`}
        onClick={onClick}
        style={style}
        disabled
        {...props}
      >
        <LoaderComponent color={colorLoading} size="sm" />
      </button>
    );
  }

  if (success) {
    return (
      <button
        className={`Button ${skin} success ${className}`}
        onClick={onClick}
        style={style}
        disabled
        {...props}
      >
        <TbSend className="icon" />
      </button>
    );
  }

  return (
    <button
      className={`Button ${skin} ${animated ? "animated" : ""} ${className}`}
      onClick={to ? () => navigation(to) : onClick}
      style={style}
      {...props}
    >
      {buttonContent}
    </button>
  );
}

ButtonAnimated.propTypes = {
  text: PropTypes.string,
  onClick: PropTypes.func,
  loading: PropTypes.bool,
  to: PropTypes.string,
  style: PropTypes.object,
  iconRight: PropTypes.oneOfType([PropTypes.bool, PropTypes.element]),
  iconLeft: PropTypes.oneOfType([PropTypes.bool, PropTypes.element]),
  skin: PropTypes.string,
  success: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  animated: PropTypes.bool,
  colorLoading: PropTypes.string,
};

export default ButtonAnimated;
